export const state = {
    loader: false,
    businessTypes:[],
    businessType: null,
  }
  